import { TextareaAutosize } from "@mui/material";
import { ReportAProblem } from "./ReportAProblem";

function ProblemReportPage({ applicationData, apiCalls }) {
  return <ReportAProblem apiCalls={apiCalls} />;
}

export default ProblemReportPage;
